export default __webpack_public_path__ + "static/media/rcfc_2021_std_p3_s1_480 3.87ff2309.png";